export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/logo_animation.fb3c0a7.svg";